import React from 'react';
import './Section2.css';


function Section2() {
  return (
    <div className='main-categories lohp-row max-width-container'>
      <h2 className='section2_title'>Explore the mentor's Specialities</h2>
      <ul className='categories-list'>
        <li>
          <a
            className='a_section2'
            href='/categories/graphics-design?source=hplo_cat_sec&amp;pos=1'
          >
            <img
              src='https://fiverr-res.cloudinary.com/npm-assets/@fiverr/logged_out_homepage_perseus/apps/graphics-design.d32a2f8.svg'
              alt='Graphics &amp; Design'
              loading='lazy'
            />
            Graphics &amp; Design
          </a>
        </li>
        <li>
          <a
            className='a_section2'
            href='/categories/online-marketing?source=hplo_cat_sec&amp;pos=2'
          >
            <img
              src='https://fiverr-res.cloudinary.com/npm-assets/@fiverr/logged_out_homepage_perseus/apps/online-marketing.74e221b.svg'
              alt='Digital Marketing'
              loading='lazy'
            />
            Digital Marketing
          </a>
        </li>
        <li>
          <a
            className='a_section2'
            href='/categories/writing-translation?source=hplo_cat_sec&amp;pos=3'
          >
            <img
              src='https://fiverr-res.cloudinary.com/npm-assets/@fiverr/logged_out_homepage_perseus/apps/writing-translation.32ebe2e.svg'
              alt='Writing &amp; Translation'
              loading='lazy'
            />
            Writing &amp; Translation
          </a>
        </li>
        <li>
          <a
            className='a_section2'
            href='/categories/video-animation?source=hplo_cat_sec&amp;pos=4'
          >
            <img
              src='https://fiverr-res.cloudinary.com/npm-assets/@fiverr/logged_out_homepage_perseus/apps/video-animation.f0d9d71.svg'
              alt='Video &amp; Animation'
              loading='lazy'
            />
            Video &amp; Animation
          </a>
        </li>
        <li>
          <a
            className='a_section2'
            href='/productmusic'
          >
            <img
              src='https://fiverr-res.cloudinary.com/npm-assets/@fiverr/logged_out_homepage_perseus/apps/music-audio.320af20.svg'
              alt='Music &amp; Audio'
              loading='lazy'
            />
            Music &amp; Audio
          </a>
        </li>
        <li>
          <a
            className='a_section2'
            href='/categories/programming-tech?source=hplo_cat_sec&amp;pos=6'
          >
            <img
              src='https://fiverr-res.cloudinary.com/npm-assets/@fiverr/logged_out_homepage_perseus/apps/programming.9362366.svg'
              alt='Programming &amp; Tech'
              loading='lazy'
            />
            Programming &amp; Tech
          </a>
        </li>
        <li>
          <a
            className='a_section2'
            href='/categories/business?source=hplo_cat_sec&amp;pos=7'
          >
            <img
              src='https://fiverr-res.cloudinary.com/npm-assets/@fiverr/logged_out_homepage_perseus/apps/business.bbdf319.svg'
              alt='Business'
              loading='lazy'
            />
            Business
          </a>
        </li>
        <li>
          <a
            className='a_section2'
            href='/categories/data?source=hplo_cat_sec&amp;pos=9'
          >
            <img
              src='https://fiverr-res.cloudinary.com/npm-assets/@fiverr/logged_out_homepage_perseus/apps/data.718910f.svg'
              alt='Data'
              loading='lazy'
            />
            Data
          </a>
        </li>
      </ul>
    </div>
  );
}

export default Section2;
